import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

import { FilterEntry } from './filter.model';

@Component({
  selector: 'wl-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.essent.scss', './filter.component.ed.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AutomationIdDirective, NgClass, FaIconComponent],
})
export class FilterComponent<T> {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() entries?: FilterEntry<T>[];
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() selected?: FilterEntry<T>;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() styleIsStretched = false;

  @Output()
  entrySelected = new EventEmitter<T>();

  clicked(entry: FilterEntry<T>) {
    this.selected = entry;
    this.entrySelected.emit(entry.value);
  }

  trackById(_: number, entry: FilterEntry<T>) {
    return entry.id;
  }
}
